import React from "react"; //check without
import * as types from "./actionTypes";
import { getLayout, getSession } from "../store/configureStore";
import * as DomainConstants from '../constants/DomainConstants';
import * as ComponentConstants from "../constants/ComponentConstants";
import mergeDeep from "../util/mergeDeep";

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function setScope(scope) {
	return {
		type: types.SET_SCOPE,
		body: scope
	};
}

export function loadDemoPageLayout(pageTitle, isNew, modelId) {
	return function (dispatch) {
		let layout = getFederatieLayout();

		layout.showHeader = !isNew;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSportOrganisatieOrganisatiePageLayout(pageTitle, isNew) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();
		resetTopNavTabSettingsSportOrganisatie(layout);

		layout.pageHeaderTitle = pageTitle;
		return dispatch(layoutUpdated(layout));
	};
}

export function loadSportOrganisatieInfrastructuurOverzichtPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();

		resetTopNavTabSettingsSportOrganisatie(layout);

		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSportOrganisatieSporttakkenPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();
		resetTopNavTabSettingsSportOrganisatie(layout);

		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSportOrganisatieInfrastructuurDetailPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();

		_disableTopNav(layout);

		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSportOrganisatieEindPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();

		Object.keys(layout.topNavTabSettings).forEach(x => layout.topNavTabSettings[x].visible = false);
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadLoginPageLayout() {
	return function (dispatch) {
		let layout = getLoginLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadTestPageLayout() {
	return function (dispatch) {
		let layout = getFederatieLayout();

		layout.showHeader = false;
		layout.showBeads = false;
		//resetTopNavTabSettingsFederatie(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadExceptionPageLayout() {
	return function (dispatch) {

		let layout = getFederatieLayout();
		layout.showHeader = false;
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNoAccessPageLayout() {
	return function (dispatch) {

		let layout = getFederatieLayout();
		layout.showHeader = false;
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadDefaultLayout() {
	return function (dispatch) {
		//todo: change this to a true new getDefaultLayout instead of the 'current default' getFederatieLayout
		return dispatch(layoutUpdated(getFederatieLayout()));
	};
}

export function loadOverzichtPageLayout() {
	return function (dispatch) {
		let layout = getFederatieLayout();

		layout.showHeader = false;
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadGemeenteOverzichtPageLayout() {
	return function (dispatch) {
		let layout = getGemeenteLayout();

		layout.showHeader = false;
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadGemeenteNiveauInstantiesPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getGemeenteLayout();

		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadFederatieSporttakkenToevoegenPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getSportOrganisatieLayout();

		_disableTopNav(layout);

		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubOrganisatiePageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.organisatie.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubIdentificatiePageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.identificatieTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubAdresPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.adresTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubSporttakkenPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.sporttakkenTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubDoelgroepPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.doelgroepTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubSocialeMediaPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.socialemediaTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubExtraCommentaarPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.extracommentaarTab.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubBevestigingPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		layout.topNavTabSettings.bevestiging.disabled = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNieuweSportclubEindPageLayout(pageTitle) {
	return function (dispatch) {
		let layout = getNieuweSportclubLayout();

		resetTopNavTabSettingsNieuweSportclub(layout);
		Object.keys(layout.topNavTabSettings).forEach(x => layout.topNavTabSettings[x].visible = false);
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function disableTopNav() {
	return function (dispatch) {
		let layout = getLayout();
		_disableTopNav(layout);
		return dispatch(layoutUpdated(layout));
	};
}

export function enableTopNav() {
	return function (dispatch) {
		let layout = getLayout();
		_enableTopNav(layout);
		return dispatch(layoutUpdated(layout));
	};
}

function _disableTopNav(layout) {
	if (!layout) {
		layout = mergeDeep({}, getLayout());
	}
	Object.keys(layout.topNavTabSettings).forEach(item => {
		layout.topNavTabSettings[item].disabled = true;
	});
}

function _enableTopNav(layout) {
	if (!layout) {
		layout = mergeDeep({}, getLayout());
	}
	Object.keys(layout.topNavTabSettings).forEach(item => {
		layout.topNavTabSettings[item].disabled = false;
	});
}

export function resetTopNavTabSettingsSportOrganisatie(layout) {
	const userType = getSession().userType;
	const hasOverzicht = userType === DomainConstants.UserTypes.FEDERATIEMEDEWERKER || userType === DomainConstants.UserTypes.GEMEENTEMEDEWERKER;
	const overzichtUrl = hasOverzicht && userType === DomainConstants.UserTypes.FEDERATIEMEDEWERKER ? "/federatie/overzicht" : "/gemeente/overzicht";
	layout.topNavTabsSet = false;
	layout.topNavTabSettings = {
		organisatie: { tabNr: 1, text: "Organisatie", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_ORGANISATIE, disabled: false, visible: true, urlSuffix: "/sportorganisatie/organisatie/", showBead: false, showAsSideNav: false },
		identificatieTab: { tabNr: 2, text: "Identificatie", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_IDENTIFICATIE, disabled: false, visible: true, urlSuffix: "/sportorganisatie/identificatie/", showBead: false, showAsSideNav: false },
		sportinfrastructuurTab: { tabNr: 4, text: "Sportinfrastructuur", color: ComponentConstants.COLOR_RED, iconType: ComponentConstants.ICON_SPORTINFRASTRUCTUUR, disabled: false, visible: true, urlSuffix: "/sportorganisatie/sportinfrastructuur/", showBead: false, showAsSideNav: false },
		adresTab: { tabNr: 3, text: "Adres", color: ComponentConstants.COLOR_GREEN_LIGHT, iconType: ComponentConstants.ICON_ADRES, disabled: false, visible: true, urlSuffix: "/sportorganisatie/adres/", showBead: false, showAsSideNav: false },
		niveauinstantiesTab: { tabNr: 10, text: "Gemeente waartoe de sportclub behoort", color: ComponentConstants.COLOR_TURQUOISE_DARK, iconType: ComponentConstants.ICON_NIVEAUINSTANTIE, disabled: false, visible: userType === DomainConstants.UserTypes.GEMEENTEMEDEWERKER, urlSuffix: "/sportorganisatie/niveauinstanties/", showBead: false, showAsSideNav: false },
		sporttakkenTab: { tabNr: 5, text: "Sporttakken", color: ComponentConstants.COLOR_GREEN, iconType: ComponentConstants.ICON_SPORTTAKKEN, disabled: false, visible: true, urlSuffix: "/sportorganisatie/sporttakken/", showBead: false, showAsSideNav: false },
		doelgroepTab: { tabNr: 6, text: "Doelgroep", color: ComponentConstants.COLOR_PINK_LIGHT, iconType: ComponentConstants.ICON_DOELGROEP, disabled: false, visible: true, urlSuffix: "/sportorganisatie/doelgroep/", showBead: false, showAsSideNav: false },
		socialemediaTab: { tabNr: 7, text: "Sociale Media", color: ComponentConstants.COLOR_PURPLE, iconType: ComponentConstants.ICON_SOCIALEMEDIA, disabled: false, visible: true, urlSuffix: "/sportorganisatie/socialemedia/", showBead: false, showAsSideNav: false },
		linksTab: { tabNr: 8, text: "Links", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_LINKS, disabled: false, visible: true, urlSuffix: "/sportorganisatie/links/", showBead: false, showAsSideNav: false },
		extracommentaarTab: { tabNr: 9, text: "Extra Commentaar", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_EXTRACOMMENTAAR, disabled: false, visible: true, urlSuffix: "/sportorganisatie/extracommentaar/", showBead: false, showAsSideNav: false },
		dienInTab: { tabNr: 99, text: "Dien In", color: ComponentConstants.COLOR_WHITE, iconType: ComponentConstants.ICON_DIENIN, disabled: false, visible: false, urlSuffix: hasOverzicht ? overzichtUrl : "/sportorganisatie/eind/", showBead: false, showAsSideNav: false, backToOverview: hasOverzicht, customNavAction: DomainConstants.CustomNavActions.DIEN_IN },
		naarOverzichtTab: { tabNr: -1, text: "Terug naar overzicht", color: ComponentConstants.COLOR_GREEN_LIGHT, iconType: ComponentConstants.ICON_TERUGNAAROVERZICHT, disabled: false, visible: hasOverzicht, urlSuffix: overzichtUrl, showBead: false, showAsSideNav: false, backToOverview: true }
	};
}

export function resetTopNavTabSettingsNieuweSportclub(layout) {
	layout.topNavTabSettings = {
		organisatie: { tabNr: 1, text: "Organisatie", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_ORGANISATIE, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/organisatie/", showBead: false, showAsSideNav: false },
		identificatieTab: { tabNr: 2, text: "Identificatie", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_IDENTIFICATIE, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/identificatie/", showBead: false, showAsSideNav: false },
		adresTab: { tabNr: 3, text: "Adres", color: ComponentConstants.COLOR_GREEN_LIGHT, iconType: ComponentConstants.ICON_ADRES, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/adres/", showBead: false, showAsSideNav: false },
		sporttakkenTab: { tabNr: 4, text: "Sporttakken", color: ComponentConstants.COLOR_GREEN, iconType: ComponentConstants.ICON_SPORTTAKKEN, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/sporttak/", showBead: false, showAsSideNav: false },
		doelgroepTab: { tabNr: 5, text: "Doelgroep", color: ComponentConstants.COLOR_PINK_LIGHT, iconType: ComponentConstants.ICON_DOELGROEP, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/doelgroep/", showBead: false, showAsSideNav: false },
		socialemediaTab: { tabNr: 6, text: "Sociale Media", color: ComponentConstants.COLOR_PURPLE, iconType: ComponentConstants.ICON_SOCIALEMEDIA, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/socialemedia/", showBead: false, showAsSideNav: false },
		extracommentaarTab: { tabNr: 7, text: "Extra Commentaar", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_EXTRACOMMENTAAR, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/andereopmerkingen/", showBead: false, showAsSideNav: false },
		bevestiging: { tabNr: 8, text: "Bevestiging", color: ComponentConstants.COLOR_RED, iconType: ComponentConstants.ICON_TERUGNAAROVERZICHT, disabled: true, visible: true, urlSuffix: "/nieuweSportclub/bevestiging/", showBead: false, showAsSideNav: false },
	};
}

export function setTabSettings(tabSettingsFromServer) {
	return function (dispatch) {
		let layout = mergeDeep({}, getLayout());

		Object.keys(layout.topNavTabSettings).forEach(x => {
			let tabSettings = layout.topNavTabSettings[x];

			if (tabSettings.tabNr >= 0) {
				const settingsFromServerForTab = tabSettingsFromServer.find(x => x.tabNr == tabSettings.tabNr);

				tabSettings.showBead = settingsFromServerForTab ? settingsFromServerForTab.hasValidationError : false;
				tabSettings.visible = settingsFromServerForTab ? settingsFromServerForTab.showTab : false;
				tabSettings.showAsSideNav = settingsFromServerForTab ? settingsFromServerForTab.showAsSideNav : false;
			}

			if (tabSettings.tabNr === 10) { //niveauInstantie (moet hier checken omdat de server niet weet wat voor user type aan de sportclub werkt)
				tabSettings.visible = getSession().userType === DomainConstants.UserTypes.GEMEENTEMEDEWERKER;
			}
		});

		return dispatch(layoutUpdated(layout));
	};
}

function getFederatieLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.FEDERATIE;
	layout.showHeader = true;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = false;
	layout.showSideNav = false;
	layout.showBeads = false;

	return layout;
}

function getGemeenteLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.GEMEENTE;
	layout.showHeader = true;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = false;
	layout.showSideNav = true;
	layout.showBeads = false;

	return layout;
}

function getSportOrganisatieLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.SPORTORGANISATIE;
	layout.showHeader = true;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = true;
	layout.showSideNav = false;
	layout.showBeads = false;

	return layout;
}

function getNieuweSportclubLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.NIEUWESPORTCLUB;
	layout.showHeader = true;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = true;
	layout.showSideNav = false;
	layout.showBeads = false;

	return layout;
}

function getLoginLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.LOGIN;
	layout.showHeader = false;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = false;
	layout.showSideNav = false;
	layout.showBeads = false;

	return layout;
}